import React from "react";
import { MapPin, Phone, Mail, Clock, Instagram, Facebook, Youtube } from "lucide-react";
import { SITE } from "./siteData";

export const Footer = () => {
  return (
    <footer data-testid="footer-section" className="bg-zinc-950 border-t border-white/10">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 grid md:grid-cols-3 gap-12">
        <div>
          <div className="flex items-center gap-3 mb-5">
            <img src={SITE.logo} alt="SVT Golden Fitness" className="h-14 w-14 object-contain" />
            <span className="font-bebas text-2xl tracking-wide text-white leading-none">
              SVT GOLDEN <span className="text-gold">FITNESS</span>
            </span>
          </div>
          <p className="text-zinc-400 text-sm font-body max-w-xs">
            Bangalore's friendly fitness home. Train hard, feel great and become your best self.
          </p>
          <div className="flex gap-3 mt-6">
            {[Instagram, Facebook, Youtube].map((Icon, i) => (
              <a
                key={i}
                href="#contact"
                data-testid={`footer-social-${i}`}
                className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-zinc-300 hover:text-gold hover:border-gold transition-colors"
              >
                <Icon size={18} />
              </a>
            ))}
          </div>
        </div>

        <div>
          <h4 className="font-bebas text-xl text-white tracking-wide mb-5">Quick Links</h4>
          <ul className="space-y-3">
            {["Home", "Programs", "Membership", "Gallery", "Contact"].map((l) => (
              <li key={l}>
                <a
                  href={`#${l.toLowerCase()}`}
                  className="text-zinc-400 hover:text-gold text-sm font-body transition-colors"
                >
                  {l}
                </a>
              </li>
            ))}
            <li>
              <a href="/login" className="text-zinc-400 hover:text-gold text-sm font-body transition-colors">
                Staff Login
              </a>
            </li>
          </ul>
        </div>

        <div>
          <h4 className="font-bebas text-xl text-white tracking-wide mb-5">Reach Us</h4>
          <ul className="space-y-4 text-sm font-body">
            <li className="flex items-start gap-3 text-zinc-400">
              <MapPin size={18} className="text-gold mt-0.5 shrink-0" /> {SITE.address}
            </li>
            <li className="flex items-center gap-3 text-zinc-400">
              <Phone size={18} className="text-gold shrink-0" />
              <a href={`tel:${SITE.phoneRaw}`} className="hover:text-gold" data-testid="footer-phone">
                {SITE.phone}
              </a>
            </li>
            <li className="flex items-center gap-3 text-zinc-400">
              <Mail size={18} className="text-gold shrink-0" /> {SITE.email}
            </li>
            <li className="flex items-start gap-3 text-zinc-400">
              <Clock size={18} className="text-gold mt-0.5 shrink-0" /> {SITE.hours}
            </li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10 py-6">
        <p className="text-center text-zinc-500 text-sm font-body">
          © {new Date().getFullYear()} SVT Golden Fitness. All rights reserved.
        </p>
      </div>
    </footer>
  );
};
